import { useMemo } from 'react';

import { AudioEvents } from './types';

export interface PlayOptions {
  name: string;
  loop?: boolean;
  start?: number; // start from point X may be useful in some situations
  delay?: number; // TODO: start with delay may be useful in some situations
  duration?: number; // audio ends after this duration is completed
}

export interface StopOptions {
  name: string;
}

export interface AudioTrigger {
  play: (options: PlayOptions) => void;
  stop: (options: StopOptions) => void;
}

export const useAudioTrigger = (channel?: string): AudioTrigger => {
  return useMemo(
    () => ({
      play: (options: PlayOptions): void => {
        const event = new CustomEvent(AudioEvents.PLAY, {
          detail: {
            name: options.name,
            channel: channel,
            loop: options.loop,
            start: options.start,
            duration: options.duration,
          },
        });
        window.dispatchEvent(event);
      },
      stop: (options: StopOptions): void => {
        const event = new CustomEvent(AudioEvents.STOP, { detail: { name: options.name, channel: channel } });
        window.dispatchEvent(event);
      },
    }),
    [channel]
  );
};
